import * as React from 'react';
import { Button, Col, Row } from 'reactstrap';
import { HomeOperationClient } from './HomeOperationClient';
import { HomeOperationConsultant } from './HomeOperationConsultant';

export const HomeOperation: React.SFC<{}> = () => {
  const [type, setType] = React.useState('client');

  const toggleType = () => {
    setType(type === 'client' ? 'consultant' : 'client');
  };

  return (
    <section  id='how-does-it-work' className='d-flex justify-content-center flex bg-white'>
      <Row  className='d-flex justify-content-center align-items-center pt-5 w-100'>
        <Col xs='12' /* className={`home-operation-${type === 'client' ? 'client' : 'consultant'}-cover`} */>
          <Row className='pt-5 d-flex justify-content-center'>
            <Col xs='12'>
              <h2 className='text-center'>
                Comment ça <strong className='text-warning'>fonctionne</strong>
              </h2>
            </Col>
          </Row>
          <Row className='d-flex justify-content-center '>
            


            <Col xs='12' sm='8' lg='4' className='d-flex justify-content-center justify-content-lg-end align-items-center mt-3 px-0'>

              <Col sm='2' className='d-flex  px-0'>
                { type === 'client'  ? ( <>
                <span  >
                  <svg  height="24"  width='5' className='d-none d-sm-block'  style={{marginTop : '20px'}}> 
                    <line  x1="0" y1="0" x2="0"  y2="400" stroke-linecap="square" stroke="rgb(188, 235, 253)" stroke-width="11"  />
                 </svg>
                </span>
                <svg height='5'  className='my-auto d-none d-sm-block'  >
                  <line  x1="0" y1="0" x2="800" y2="0" stroke-linecap="square" stroke="rgb(188, 235, 253)" stroke-width="11"  />
                </svg>
                </> ) : <> </>
                }
              </Col>
              <Col sm='8' className='d-flex  justify-content-center  px-0' >
              
                  <svg height='5'  className='my-auto d-none d-sm-block'  >
                  { type === 'client'  ? ( <>
                    <line  x1="0" y1="0" x2="300" y2="0" stroke-linecap="square" stroke="rgb(188, 235, 253)" stroke-width="11"  />
                    </> ) : <> </>
                 }  
                 </svg>
                  <Button  style={{minWidth: '300px'  , maxWidth: '300px' , height: '40px'}} 
                    className={`text-uppercase text-white bg-${
                      type === 'client' ? 'primary' : 'secondary-HomeOperation '
                    } border-0 w-100 ` }
                    onClick={toggleType}
                  >
                    Je suis client
                  </Button>
                  <svg height='5'  className='my-auto d-none d-sm-block' />
                  
              </Col>
              <Col sm='2'  className='d-flex  px-0'/>

            </Col>



            <Col xs='12' sm='8' lg='4'   className='d-flex justify-content-center justify-content-lg-start px-0'>  

              <Col sm='2' className='d-flex  px-0'>
                { type === 'client'  ? ( <>
                <span  >
                  <svg  height="56"  width='5' className='d-none d-sm-block d-lg-none'> 
                    <line  x1="0" y1="0" x2="0"  y2="400" stroke-linecap="square" stroke="rgb(188, 235, 253)" stroke-width="11"  />
                </svg>
                </span>
                </> ) : <> </>
                }
              </Col>        


              <Col sm='8' className='d-flex  justify-content-center  px-0  mt-3 align-items-center' >
                <svg height='5'  className='my-auto d-none d-sm-block' />
                <Button  style={{minWidth: '300px'  , maxWidth: '300px' , height: '40px' , zIndex : 1}}
                  className={`text-uppercase text-white bg-${
                    type === 'consultant' ? 'primary' : 'secondary-HomeOperation '
                  } border-0 w-100`}
                  onClick={toggleType}
                >
                  Je suis freelance
                </Button>
                <svg height='5'  className='my-auto d-none d-sm-block'  >
                  { type === 'consultant'  ? ( <>
                    <line  x1="0" y1="0" x2="300" y2="0" stroke-linecap="square" stroke="rgb(188, 235, 253)" stroke-width="11"  />
                    </> ) : <> </>
                 }  
                 </svg>
              </Col>
              <Col sm='2' className='d-flex  px-0 mt-3'>
                { type === 'consultant'  ? ( <>
                  <svg height='5'  className='my-auto d-none d-sm-block'  >
                    <line  x1="0" y1="0" x2="300" y2="0" stroke-linecap="square" stroke="rgb(188, 235, 253)" stroke-width="11"  />
                  </svg>
                  <span  >
                    <svg  height="24"  width='5' className='d-none d-sm-block'  style={{marginTop : '20px'}}> 
                      <line  x1="0" y1="0" x2="0"  y2="400" stroke-linecap="square" stroke="rgb(188, 235, 253)" stroke-width="11"  />
                  </svg>
                  </span>
                </> ) : <> </>
                }
              </Col>

            </Col>
          </Row>
         
          {type === 'client' ? (
            <HomeOperationClient />
          ) : (
            <HomeOperationConsultant />
          )}
        </Col>
      </Row>
    </section>
  );
};



// WEBPACK FOOTER //
// ./src/components/HomePage/HomeOperation/HomeOperation.tsx